module.exports = __webpack_public_path__ + "media/images/event-hero-bg-9fcdab0e96b9ff17727df315753f441d.svg";